import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useLocation, useNavigate } from 'react-router-dom';
import NumberFlow from '@number-flow/react';

import { Card, CardHeader } from '../components/Card';
import { SpendingList, SpendingListItem } from '../components/SpendingList';
import { BucketList, BucketListItem } from '../components/BucketList';
import { PeopleList, PeopleListItem } from '../components/PeopleList';
import { Button } from '../components/Control.js';

import { SVGMoneyNote, SVGBucket, SVGUsers, SVGLayout } from '../components/SVG';

export default function Home({numberValue, fuelData, groceriesData}) {
    return (
        <div className='flex flex-col relative px-3 gap-3 body-spacing'>
            <div className='block relative bg-teal-50 dark:bg-teal-950 px-8 py-6 rounded-2xl ring-1 ring-black/10 dark:ring-white/10 ring-inset shadow-xl shadow-black/5'>
                <div className='flex relative justify-between'>
                    <div className='flex flex-col relative'>
                        <span className='block text-lg font-bold dark:text-white'>Available to spend</span>
                        <NumberFlow className='block text-3xl font-bold text-teal-500' value={numberValue} format={{ style: 'currency', currency: 'GBP' }} />
                    </div>
                    <div className='flex flex-col relative items-end'>
                        <span className='block text-lg font-bold dark:text-white'>Days left</span>
                        <NumberFlow className='block text-3xl font-bold text-teal-500' value={24} />
                    </div>
                </div>
            </div>
            <Card>
                <CardHeader heading='Buckets' icon={SVGBucket} to={"/buckets"} />
                <BucketList>
                    <BucketListItem label='Fuel' emoji='⛽' valueLeft={fuelData.valueLeft} percentage={fuelData.percentage} colour={fuelData.colour} />
                    <BucketListItem label='Groceries'  emoji='🥦' valueLeft={groceriesData.valueLeft} percentage={groceriesData.percentage} colour={groceriesData.colour} />
                </BucketList>
            </Card>
            <Card>
                <CardHeader heading='People' icon={SVGUsers} to={"/people"} />
                <PeopleList>
                    <PeopleListItem name='Julie Gorringe' initials='JG' colour='purple' balance={104.5} />
                    <PeopleListItem name='Codey Miller' pictureSrc='https://r2.serverbook.app/user-image/5ea1de96671e162844589c840ab3e574-medium.jpg' balance={-46.6} />
                </PeopleList>
            </Card>
            <Card>
                <CardHeader heading='Recent Spending' icon={SVGMoneyNote} to={"/spending"} />
                <SpendingList>
                    <SpendingListItem label='Test 1' description={'Lipsum'} value={'£20.00'} />
                    <SpendingListItem label='Test 2' description={'Lipsum'} value={'£20.00'} />
                    <SpendingListItem label='Test 3' value={'£20.00'} />
                    <SpendingListItem label='Test 4' description={'Lipsum'} value={'£20.00'} />
                </SpendingList>
            </Card>
            <div className='flex flex-col items-center gap-2'>
                <Button type='secondary' label='Change Layout' icon={SVGLayout} />
            </div>
        </div>
    );
}